import {z} from '@hono/zod-openapi';

export const VoiceDebugProfileListResponseSchema = z
  .object({
    schemaVersion: z.literal('1.0.0'),
    profiles: z
      .array(
        z
          .object({
            profileId: z.string().min(1).max(128),
            label: z.string().min(1).max(256),
            capabilityMode: z.enum(['fixture', 'live']),
            scenarios: z
              .array(
                z
                  .object({
                    scenarioId: z.string().min(1).max(128),
                    versions: z.array(z.string().min(1).max(64)).max(32).readonly(),
                  })
                  .strict()
              )
              .max(32)
              .readonly(),
          })
          .strict()
      )
      .max(64)
      .readonly(),
  })
  .strict()
  .openapi('VoiceDebugProfileListResponseSchema');

export type VoiceDebugProfileListResponse = z.infer<typeof VoiceDebugProfileListResponseSchema>;
